export default __webpack_public_path__ + "static/media/โปรโมชั่นวันเกิดรับโบนัส500บาทv2.9c0f5f12.png";